import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Typography, Card } from 'antd';
import Header from '../../Shared/Header';
import backIcon from "../../../assets/icons/backIcon.svg";
import { getSoilSolutionAnalysisInfo } from '../../../Utils/analysis/soilSolutionAnalysis';
import moment from 'moment';
import { useSelector } from 'react-redux';
import Loading from '../../Shared/Loading';
import { exportTableToExcel } from '../../../Helpers/Excel/export';
import excelPng from '../../../assets/images/excel.png';



const { Title } = Typography;

const ViewSSolution = () => {
    const { exploitationId, analysisId } = useParams();
    const [analysisData, setAnalysisData] = useState(null);
    const [loading, setLoading] = useState(true);
    const userRole = useSelector((state) => state.user.userRole.name);
    const userInfo = useSelector((state) => state.user.userInfo);



    const userLink = () => {
        if (userRole === 'client') {
            return '/client';
        } else if (userRole === 'admin' || userRole === 'superadmin') {
            return '/admin';
        } else if (userRole === 'domain_manager') {
            return '/domain-manager';
        } else if (userRole === 'exploitation_manager') {
            return '/exploitation-manager';
        }
    };

    useEffect(() => {
        fetchAnalysisDetails();
    }, [analysisId]);

    const fetchAnalysisDetails = async () => {
        setLoading(true);
        try {
            const details = await getSoilSolutionAnalysisInfo(analysisId);
            setAnalysisData(details.data);
        } catch (error) {
            console.error('Erreur lors de la récupération des détails de l\'analyse:', error);
        }
        setLoading(false);
    };

    const HeaderTab = ({ text }) => (
        <th className="border border-gray-300 bg-gray-300 table_heeader px-2 py-2">{text}</th>
    );



    const handleExport = () => {
        const info = [
            'Analyse de Solution du Sol',
            `Date de réalisation: ${moment(analysisData.date_realisation).format('DD/MM/YYYY')}`,
            `Laboratoire: ${analysisData.laboratoire}`,
            `Échantillon: ${analysisData.echantillon}`,
            'Type de sol: ' + analysisData.type_sol,
            `Vanne associée: ${analysisData.vanne_associee}`
        ];

        const titles = ['Paramètres de la solution du sol', 'Autres paramètres'];
        const tableIDs = ['soilSolutionParametersTable', 'otherParametersTable'];
        const filename = `Analyse_Solution_Sol_${analysisId}`;
        const user = `${userInfo.first_name} ${userInfo.last_name}`;

        exportTableToExcel(info, tableIDs, filename, titles, null, user);
    }


    const soilSolutionParameters = [
        { key: 'calcium', label: 'Calcium', unit: 'mg/L' },
        { key: 'magnesium', label: 'Magnésium', unit: 'mg/L' },
        { key: 'potassium', label: 'Potassium', unit: 'mg/L' },
        { key: 'sodium', label: 'Sodium', unit: 'mg/L' },
        { key: 'ammonium', label: 'Ammonium', unit: 'mg/L' },
        { key: 'bicarbonates', label: 'Bicarbonates', unit: 'mg/L' },
        { key: 'nitrates', label: 'Nitrates', unit: 'mg/L' },
        { key: 'chlorures', label: 'Chlorures', unit: 'mg/L' },
        { key: 'phosphates', label: 'Phosphates', unit: 'mg/L' },
        { key: 'sulfates', label: 'Sulfates', unit: 'mg/L' },
        { key: 'fer', label: 'Fer', unit: 'mg/L' },
        { key: 'cuivre', label: 'Cuivre', unit: 'mg/L' },
        { key: 'manganese', label: 'Manganèse', unit: 'mg/L' },
        { key: 'zinc', label: 'Zinc', unit: 'mg/L' },
        { key: 'molybdene', label: 'Molybdène', unit: 'mg/L' },
        { key: 'bore', label: 'Bore', unit: 'mg/L' },
    ];

    const otherParameters = [
        { key: 'somme_anion', label: 'Somme des anions', unit: 'meq/L' },
        { key: 'somme_cation', label: 'Somme des cations', unit: 'meq/L' },
        { key: 'ph', label: 'pH', unit: '' },
        { key: 'ec', label: 'Conductivité électrique (EC)', unit: 'mS/cm' },
    ];



    if (loading) {
        return <Loading />;
    }



    return (
        <div className="bg-white h-full">
            <Header title="Voir l'Analyse de Solution du Sol" />
            <div className="h-[calc(100%-100px)] p-6">
                <Link
                    to={`${userLink()}/exploitation/${exploitationId}/analysis/solution-sol`}
                    className="cursor-pointer flex pl-5 gap-2 mt-4"
                >
                    <img src={backIcon} alt="" className="w-5" />{" "}
                    <div className="font-semibold text-base text-indigo-600">
                        {" "}
                        Retour
                    </div>
                </Link>

                <div className="flex justify-end mb-4">
                    <div
                        className="flex gap-3 border p-2 hover:bg-green-200 rounded-md transition-all cursor-pointer"
                        onClick={handleExport}
                    >
                        <span className="font-bold text-lg">Export :</span>
                        <img
                            src={excelPng}
                            alt=""
                            className="w-8"
                        />
                    </div>
                </div>
                <Card className="p-4 max-w-[900px] mx-auto">
                    <Title level={4}>Informations générales</Title>
                    <div>
                        <InfoItem label="Date de réalisation" value={moment(analysisData?.date_realisation).format('DD/MM/YYYY')} />
                        <InfoItem label="Laboratoire" value={analysisData?.laboratoire} />
                        <InfoItem label="Échantillon" value={analysisData?.echantillon} />
                        <InfoItem label="Vanne associée" value={analysisData?.vanne_associee} />
                        <InfoItem label="Type de sol" value={analysisData?.type_sol} />

                    </div>
                </Card>

                <Card className="p-4 max-w-[900px] mx-auto mt-6">:
                    <Title level={4}>Paramètres de la solution du sol</Title>
                    <table className="w-full border-collapse border border-gray-300 mb-4" id='soilSolutionParametersTable'>
                        <thead>
                            <tr>
                                <HeaderTab text="Paramètre" />
                                <HeaderTab text="Valeur" />
                                <HeaderTab text="Unité" />
                            </tr>
                        </thead>
                        <tbody>
                            {soilSolutionParameters.map(param => (
                                <tr key={param.key}>
                                    <td className="border border-gray-300 px-2 py-2">{param.label}</td>
                                    <td className="border border-gray-300 px-2 py-2">{analysisData?.[param.key]}</td>
                                    <td className="border border-gray-300 px-2 py-2">{param.unit}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Card>

                <Card className="p-4 max-w-[900px] mx-auto mt-6">
                    <Title level={4}>Autres paramètres</Title>
                    <table className="w-full border-collapse border border-gray-300 mb-4" id='otherParametersTable'>
                        <thead>
                            <tr>
                                <HeaderTab text="Paramètre" />
                                <HeaderTab text="Valeur" />
                                <HeaderTab text="Unité" />
                            </tr>
                        </thead>
                        <tbody>
                            {otherParameters.map(param => (
                                <tr key={param.key}>
                                    <td className="border border-gray-300 px-2 py-2">{param.label}</td>
                                    <td className="border border-gray-300 px-2 py-2">{analysisData?.[param.key]}</td>
                                    <td className="border border-gray-300 px-2 py-2">{param.unit}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Card>
            </div>
        </div>
    );
};


const InfoItem = ({ label, value }) => (
    <div>
        <span className="font-semibold">{label}: </span>
        <span>{value}</span>
    </div>
);


export default ViewSSolution;